import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@v2/components';
import { SubOfferingRowProps } from './types';
import { styles } from '../../styles';

const SubOfferingRow: React.FC<SubOfferingRowProps> = ({
  entityName,
  displayNameInput,
  onDelete,
  deleteAriaLabel = 'Delete sub offering',
  deleteDisabled,
}) => (
  <li className={styles.listItem}>
    <div className={styles.listItemHeader}>
      <div>
        <div className={styles.entityLabel}>Entity name</div>
        <div className={styles.entityValue}>{entityName}</div>
      </div>
      <div className={styles.listItemCta}>
        <Button
          variant="ghost"
          size="sm"
          onClick={onDelete}
          disabled={deleteDisabled}
          icon={<FontAwesomeIcon icon={faTrash} />}
          aria-label={deleteAriaLabel}
          className="tw-text-neutral-500 hover:tw-text-red-600 hover:tw-bg-red-50"
        />
      </div>
    </div>
    <div className={styles.listItemBody}>
      <span className={styles.displayNameInput}>{displayNameInput}</span>
    </div>
  </li>
);

export default SubOfferingRow;
